module.exports = __webpack_public_path__ + "img/car_03.d365d32c.jpg";